import { Col, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import { formatFiDate } from "../utils/date";
import { localePath } from "../i18n/config";

const blogURI = (article: any) => article?.url || article?.id;

const ArticleFeatured = (params: any) => {
    const { featured_article } = params;
    const history = useHistory();
    const createdAtStr = formatFiDate(featured_article?.createdAt);
    const blogBase = localePath("blog");

    return (
        <div className="blog-wrapper">
            <div className="featured-article block">
                <div className="featured-article-card-div">
                    <div
                        className="article_in_blog"
                        onClick={() => {
                            history.push(`${blogBase}/${blogURI(featured_article)}`);
                        }}
                    >
                        <Row className="featured-article-card">
                            <Col md={7} xs={12} className="featured-article-card-image">
                                {featured_article.coverType === "Image" && <img src={featured_article.cover} alt="crop" />}
                                {featured_article.coverType === "Youtube" && <img src={`https://img.youtube.com/vi/${featured_article?.cover}/maxresdefault.jpg`} alt="crop" />}
                                {featured_article?.coverType === "Video" && (
                                    <video
                                        src={featured_article?.cover}
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                        }}
                                    ></video>
                                )}
                            </Col>
                            <Col md={5} xs={12} className="featured-article-card-body">
                                <p className="article-category">{featured_article.topics && featured_article.topics.split(",")?.[0]}</p>
                                <h3>{featured_article?.title}</h3>
                                <p className="featured-article-card-description">{featured_article?.contentPreview}</p>
                                {createdAtStr && <p className="featured-article-card-date">{createdAtStr}</p>}
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ArticleFeatured;
